import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-08886823")

_pushScopeId("data-v-08886823")
const _hoisted_1 = {
  key: 0,
  class: "drop-down-file__options"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _directive_click_outside_element = _resolveDirective("click-outside-element")

  return _withDirectives((_openBlock(), _createBlock("div", {
    class: ["drop-down-file", { 'drop-down-file--active': $setup.active }]
  }, [
    _createVNode("button", {
      class: "btn default-btn drop-down-file__btn",
      disabled: $props.disabled,
      onClick: _cache[1] || (_cache[1] = $event => ($setup.active = !$setup.active))
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t('commands.download')) + " ", 1 /* TEXT */),
      _createVNode(_component_svg_icon, { name: "arrowdown2-white" })
    ], 8, ["disabled"]),
    ($setup.active)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.options, (option, optionInd) => {
            return (_openBlock(), _createBlock("div", {
              key: optionInd,
              class: "drop-down-file__option",
              onClick: $event => ($setup.selectType(option.type))
            }, [
              _createVNode("span", null, _toDisplayString(option.name), 1),
              _createVNode(_component_svg_icon, {
                name: option.icon
              }, null, 8, ["name"])
            ], 8, ["onClick"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("", true)
  ], 2)), [
    [_directive_click_outside_element, () => ($setup.active = false)]
  ])
})